import { PROD_SITES_DIR, useProdSitePaths } from './server/site-paths.js'

const SITE = process.env.SITE || 'tofjan.online'

/**
 * Single codebase, multiple sites.
 *
 * Loading strategy:
 * - Browser (client): Prefers window.__SITE_CONFIG__ (injected at runtime by server),
 *   falls back to build-time __SITE_CONFIG__ if not available
 * - Server production (on deploy host): Loads from /var/www/portfolio-sites/{sitename}/
 * - Server development / local production: Loads from codebase ./sites/{sitename}/
 *
 * Theme colors are now stored in the database (properties) and loaded dynamically
 * in lib/server.js on each SSR request. This allows theme changes without rebuild.
 *
 * Content is loaded fresh from the database on each SSR request in lib/server.js
 * to ensure the frontend always shows the latest data from the same source as admin.
 */

// Detect if we're running in a browser environment
const isBrowser = typeof window !== 'undefined'

let site

if (isBrowser) {
    // Browser: prefer runtime-injected config (set by server in admin.html)
    // Falls back to build-time config if not available
    // eslint-disable-next-line no-undef
    site = window.__SITE_CONFIG__ || (typeof __SITE_CONFIG__ !== 'undefined' ? __SITE_CONFIG__ : {})
} else if (useProdSitePaths()) {
    // Server production: load from /var/www/portfolio-sites/{sitename}/
    const siteConfigPath = `${PROD_SITES_DIR}/${SITE}/site.config.js`
    const siteModule = await import(/* @vite-ignore */ siteConfigPath)
    site = siteModule.default
} else {
    // Local dev or local production build: load from codebase ./sites/{sitename}/
    const siteModule = await import(/* @vite-ignore */ `../sites/${SITE}/site.config.js`)
    site = siteModule.default
}

export { site }
